export const quickJournalChromaFlareTheme = {
    id: "chromaflare",
    label: "Chroma Flare",
    containerClassName: "QuickJournalContainerChromaFlareV1",
    overlay: {
        backgroundColor: "#292827",
        backgroundImage: "radial-gradient(ellipse at 80% 26%, rgba(184, 198, 216, .12), transparent 55%), radial-gradient(ellipse at 22% 78%, rgba(211, 177, 120, .16), transparent 60%), linear-gradient(145deg, #323232, #252422 65%, #1c1c1b)",
    },
    backdrop: {
        backgroundColor: "#242321",
        topIos: "calc(100% - 12px)",
        topDefault: "calc(100% - 7px)",
        width: "max(640px, 100vw)",
        height: "280px", minHeight: "280px", maxHeight: "280px",
        background: "radial-gradient(ellipse at 48% 30%, #554b3c 0%, #2a2826 45%, #141617 100%)",
        boxShadow: "inset 0 1px rgba(244, 222, 170, .12)",
    },
    recentEntry: {
        color: "#ece6d9",
        textShadow: "0 0 9px rgba(255, 228, 181, .12)",
        timestampColor: "#b0a798",
    },
    input: {
        color: "#fff8e9",
        textShadow: "0 -1px 0 rgba(255, 255, 255, .38), -1px 0 1px rgba(167, 207, 239, .36), 1px 0 1px rgba(255, 209, 139, .42), 0 0 4px rgba(255, 226, 170, .48), 0 0 8px rgba(239, 204, 142, .18)",
        cursorLow: "#dfcda4", cursorMid: "#efe0bd", cursorHigh: "#fff5db",
    },
    heatmap: {
        containerColor: "#e4d8bd",
        cellBackground: (level: number) => {
            if (level <= 0) return "rgba(228, 216, 189, .055)";
            if (level >= 4) return "#fff2cb";
            if (level === 3) return "#d9c393";
            if (level === 2) return "#aca994";
            return "#646f75";
        },
        cellBoxShadow: "0 0 6px rgba(242, 217, 163, .1)",
        flashBoxShadow: "0 0 12px rgba(255, 246, 221, .95)",
        hoverOutline: "1px solid #fff0ce", inactiveOpacity: .34, activeOpacity: 1,
    },
    toggle: {
        color: "#e4d5b7", opacity: .8,
        shadow: "drop-shadow(0 0 5px rgba(255, 219, 153, .3))",
        transform: "rotate(-135deg)",
    },
    switcher: {
        border: "rgba(224, 216, 200, .28)", background: "rgba(33, 33, 32, .62)",
        text: "#c8c1b4", activeBackground: "rgba(226, 208, 166, .2)",
        activeText: "#fff2d8", activeBorder: "rgba(255, 228, 175, .7)",
    },
} as const;
